<!--
 * @Descripttion: 福利列表
 * @Author: liaoyijun
 * @Date: 2021-10-22 14:00:01
 * @LastEditors: chenjinsheng
 * @LastEditTime: 2021-11-12 14:52:43
-->
<template>
    <div class="welfare-list--container">
        <div class="welfare-buttom">
            <div class="welfare-buttom-left">
                <el-badge class="button-badge">
                    <el-button size="mini" @click="changeStatus('')">全部</el-button>
                </el-badge>
                <el-badge class="button-badge">
                    <el-button size="mini" @click="changeStatus('3')">只看有效</el-button>
                </el-badge>
                <el-badge class="button-badge">
                    <el-button size="mini" @click="changeStatus('2')">只看失效</el-button>
                </el-badge>
            </div>
            <div class="welfare-buttom-right">
                <el-select
                    v-model="reqParams.pulishDateCode"
                    placeholder="最近30天"
                    size="mini"
                    style="width:100px ;margin-right: 10px;"
                    @change="handleSelectDate"
                >
                    <el-option v-for="item in dateOptions" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>

                <el-button size="mini" @click="sortDate">
                    发布时间
                    <div class="date-sort">
                        <i :class="['el-icon-caret-top', { active: reqParams.pulishDateSort === '1' }]"></i>
                        <i :class="['el-icon-caret-bottom', { active: reqParams.pulishDateSort === '2' }]"></i>
                    </div>
                </el-button>
            </div>
        </div>

        <div v-loading="loading" class="img-box">
            <div v-for="(item, index) in data" :key="index" class="img-item" @click="goWelFareDetail(item)">
                <div class="img-item-picture">
                    <img :src="item.image" alt="" />
                    <div v-show="item.status === '2'" class="expired-img">
                        <img src="@/assets/pics/user-center/expired.png" alt="" />
                    </div>
                </div>

                <div class="img-item-text">
                    <div class="img-item-text-title">
                        <span class="title">{{ item.benefitContent }}</span>
                        <span class="describe">{{ item.benefitSummary }}</span>
                    </div>
                    <div class="img-item-text-time">
                        {{ item.updateDate }}
                    </div>
                </div>
            </div>
        </div>
        <div v-show="data.length === 0" class="noData">
            <no-empty>暂无数据</no-empty>
        </div>
    </div>
</template>

<script>
import { getBenefitList } from "@/api";
import NoEmpty from "@/components/no-empty";
export default {
    name: "WelfareCardList",
    components: { NoEmpty },
    props: {
        tabId: {
            type: String,
            default: "",
        },
    },
    data() {
        return {
            loading: false,
            reqParams: {
                benefitCategoryId: "",
                status: "",
                current: 1,
                size: 100,
                pulishDateCode: "1", // 发布时间编码1最近30天2最近半年3全年空全部
                pulishDateSort: "1", // 发布时间排序1正序2倒序默认正序
            },
            data: [],
            dateOptions: [
                {
                    value: "1",
                    label: "近30天",
                },
                {
                    value: "2",
                    label: "半年",
                },
                {
                    value: "3",
                    label: "今年",
                },
                {
                    value: "",
                    label: "全部",
                },
            ],
        };
    },
    computed: {
        sort() {
            return this.pulishDateSort === "1";
        },
    },
    methods: {
        goWelFareDetail(item) {
            if (item.benifitType === 1) {
                window.open(item.url);
            } else {
                this.$router.push(`/work-portal/welfare-details?id=${item.id}`);
            }
        },
        // 选择日期
        handleSelectDate(code) {
            this.reqParams.pulishDateCode = code;
            this.getBenefitList(this.tabId);
        },
        // 设置有效无效
        changeStatus(type) {
            this.reqParams.status = type;
            this.getBenefitList(this.tabId);
        },
        // 日期排序
        sortDate() {
            const sort = this.reqParams.pulishDateSort;
            this.reqParams.pulishDateSort = sort === "1" ? "2" : "1";
            this.getBenefitList(this.tabId);
        },
        // 获取福利列表
        async getBenefitList(id) {
            this.loading = true;
            try {
                const { code, body, message } = await getBenefitList({
                    ...this.reqParams,
                    benefitCategoryId: id,
                });
                if (code === "0000") {
                    this.data = body ? body.records : [];
                } else {
                    this.$message.error(message);
                }
            } catch (err) {
                this.$message.error(err.data.message || "系统错误");
            }
            this.loading = false;
        },
        reset() {
            this.reqParams = {
                benefitCategoryId: "",
                status: "",
                current: 1,
                size: 100,
                pulishDateCode: "1", // 发布时间编码1最近30天2最近半年3全年空全部
                pulishDateSort: "1", // 发布时间排序1正序2倒序默认正序
            };
        },
    },
};
</script>
<style lang="scss" scoped>
@import "../style.scss";
</style>
